/**
 * @created: 2020/4/15 17:41
 * @desc 保理发行
 * @author: Colorfule
 * @version : v1.0
 */

import request from '@/plugins/http'
import qs from 'qs'

// 获取列表
export const getListData = params => {
  return request.get('/mer/factoring/publish/list', params)
}

// 获取商户详情
export const getMerchantDetails = params => {
  return request.get('/mer/factoring/publish/getMerchantDetail', params)
}

// 获取渠道反馈信息
export const getBankFeedback = params => {
  return request.get('/mer/factoring/publish/getBankFeedback', params)
}

// 发行
export const onPublishConfirm = data => {
  return request.post('/mer/factoring/publish/confirm', data, { json: true })
}

//  批量保理发行
export const batchConfirm = data => {

  return request.post('/mer/factoring/publish/batchConfirm', data, { json: true })
}
